import cx from 'classnames';
import Link from 'next/link';
import React from 'react';

import styles from './LogoV2.module.scss';
import MedrecruitLogoV2 from './assets/MedrecruitLogoV2.svg';
import Mewo from './assets/Mewo.svg';

type LogoType = 'medrecruit-full' | 'medrecruit-short';

export type LogoV2Props = {
  className?: string;
  onClick?: () => void;
  type?: LogoType;
};

const altText = 'Medrecruit. A Medworld partner.';

const LogoV2 = ({ className, onClick, type = 'medrecruit-full' }: LogoV2Props) => (
  <Link
    prefetch={false}
    href="/"
    passHref
    onClick={onClick}
    className={cx(styles.container, className)}
  >
    {type === 'medrecruit-full' && <MedrecruitLogoV2 aria-label={altText} />}
    {type === 'medrecruit-short' && <Mewo aria-label={altText} />}
  </Link>
);

export default LogoV2;
